import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './assets/locales/resource';

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'zh-TW',
  lng: 'zh-TW',

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
